import getBase from '@/api/base'
const get = getBase(true).get
const post = getBase(true).post

export const userStatus = () => get('/user/current/status')
export const isSessionAlive = () => get('/user/current/session')
export const userExclusive = () => post('/user/exclusive')
export const clearToken = () => get('/user/clear')
